"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getDefaultMorningstarProps = exports.HocMorningstarRatings = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _recompose = require("recompose");

var _ramda = require("ramda");

var _summary_header_morning_star = require("../../components/summary_header_morning_star");

var _summary_header_morning_star2 = _interopRequireDefault(_summary_header_morning_star);

var _collection_utility = require("../../../../packages/common-utilities/src/collection_utility");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var HocMorningstarRatings = exports.HocMorningstarRatings = (0, _ramda.compose)((0, _recompose.mapProps)(function (_ref) {
  var fund = _ref.fund,
      breakpoint = _ref.breakpoint,
      isAEM = _ref.isAEM,
      useTooltipWrapper = _ref.useTooltipWrapper;

  return _extends({}, getDefaultMorningstarProps({ fund: fund, breakpoint: breakpoint, isAEM: isAEM }), {
    useTooltipWrapper: useTooltipWrapper
  });
}))(_summary_header_morning_star2.default);

var getDefaultMorningstarProps = exports.getDefaultMorningstarProps = function getDefaultMorningstarProps(_ref2) {
  var fund = _ref2.fund,
      breakpoint = _ref2.breakpoint,
      isAEM = _ref2.isAEM;

  var visibleDataPoints = fund.visibleData.visibleDataPoints;
  var formattingRules = fund.visibleData.formattingRules;
  return {
    morningstarRating: fund.shareClass.morningstarRating,
    peerGroupCategory: _collection_utility.CollectionUtility.includes(visibleDataPoints, 'MAP_PEER_GROUP_CATEGORY_TO_MSTAR_CATEGORY') ? fund.shareClass.morningstarRatingCategory : null,
    breakpoint: breakpoint,
    isAEM: isAEM,
    disclosure: fund.disclosures[fund.shareClass.cusip] ? fund.disclosures[fund.shareClass.cusip] : fund.disclosures,
    additionalClassName: "",
    visibleDataPoints: visibleDataPoints,
    formattingRules: formattingRules
  };
};